import {usePaginatedViewVariablesContext} from '../state-providers/memex-items/context/paginated-view-variables'
import type {PaginatedMemexItemsQueryVariables} from '../state-providers/memex-items/queries/types'
import {useEnabledFeatures} from './use-enabled-features'

export const useIsFetchingVariable = (trackedVariable: keyof PaginatedMemexItemsQueryVariables) => {
  const context = usePaginatedViewVariablesContext()
  const {memex_reduce_view_shifts} = useEnabledFeatures()
  if (!memex_reduce_view_shifts) return false
  return context?.staleVariable === trackedVariable
}
